import type { FaireProductEntity } from "../../entity_types/product";

export const p_gnhzdfa9uq: FaireProductEntity = {
  token: "p_gnhzdfa9uq",
  type: "product",
  name: "Electric Tides Soleil All Day Candle",
  brandToken: "b_37jvy57d59",
  brandName: "Electric Tides",
  imageUrl:
    "https://cdn.faire.com/fastly/a6d2a4f3c62a4edec7d36e54ede9839bcaac45d235a2bd9d2d1f8eef83a273ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/511e217525c9dc8de763983a3c21f80b62873a6d0eb405638ac141b5e4d227d8.jpeg",
    "https://cdn.faire.com/fastly/6c9915a972cc3690c8307167d795a05b40a71f5b729ce55768779337c589f3fb.jpeg",
    "https://cdn.faire.com/fastly/740f8b20c3ca88e677780134745216c85442e3927cf273e5eaf71a38e6af98e3.jpeg",
  ],
  priceDollars: 16,
  description:
    "Electric Tides Soleil All Day Candle\n\nSun rays all day, every day. Warm notes of sandalwood and fig are comforting like the sun on your soul. Energizing yuzu and aromatic cardamom make it truly shine.\n\nNotes: Sandalwood, fig, yuzu blossom, cardamom\n\nMade by the beach in Aptos, CA\n\n—\n8.5oz (250ml) \nWhite ceramic tumbler custom engraved with Electric Tides\nSoy wax scented candle\n50-hour burn time",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:24.259Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
